export enum GroupFormOptionKeys {
  TOTAL_SUM = 'total_sum',
  SEPARATELY = 'separately'
}
